module.exports = __webpack_public_path__ + "new2.2a34836f.png";